import React from 'react';
import { Tabs } from 'antd';

import { IStoneGroup } from '../../../../sharedInterfaces';
import { StyledArrow, OptionsContainer, SectionTitle } from './Stones-styled';
import { TabSelect, isMobile, isLowHeight, StoneSizeSlider,Dropdown } from '../../ui-helpers';
import { ITabSelectTab } from '../../ui-helpers/TabSelect/TabSelect';

import {
  Image,
  OptionItem,
  SliderTitle,
  StoneConfigs,
  StoneItem,
  SliderContainer
} from './Stones-styled';
import { MenuSection } from '../Materials/Materials-styled';
import { isVeryLowHeight } from '../../../shared/UIHelpers/Functions/Functions';

import { TabContainer } from '../Tab-style';
import { CARAT_CONVERSION_CHARTS } from '../../../../Model/CaratSizes';


const { TabPane } = Tabs;

interface IOptionProps {
  option:string,
  assetURI:string,
  isSelected:boolean,
  onClick:(value:any)=>void,
}

const Option:React.FunctionComponent<IOptionProps> = (props) => {
  const { option, assetURI, isSelected, onClick } = props;

  return (
    <OptionItem
      onClick={() => onClick(option)}
    >
      <Image
        width={52}
        height={52}
        src={`${assetURI}/images/stones/${option}.png`}
        showBorder={isSelected}
        borderWidth={3}
      />
      {option}
    </OptionItem>
  )
}


interface Props {
  stoneCut:'Brilliant'|'Princess'|'Baguette',

  stoneCount:number,
  stoneCountOptions:number[],
  onStoneCountChange:(value:number)=>void

  stoneSize:number,
  stoneSizeOptions:number[],
  onStoneSizeChange:(value:number)=>void,

  stoneGroups:IStoneGroup[],
  onStoneGroupChange:(value:IStoneGroup)=>void,

  currentMenuStoneGroup:IStoneGroup,
  onCurrentMenuStoneGroupChange:(setTo:string)=>void,

  scrolling:boolean,
  assetURI:string
}

export default class extends React.Component<Props,{}> {
  constructor(props:Props) {
    super(props);
  };// /constructor()

  onParameterChange = (group:string, param:any, value:any) => {
    const { stoneGroups } = this.props;
    const editedStoneGroup = stoneGroups.find(({ name }) => name === group);

    this.props.onStoneGroupChange({
      ...editedStoneGroup,
      [param]: value,
    });
  };  

  private _getSize(sg:IStoneGroup,stoneSize){
    const { stoneCut } = this.props;
    const caratConversionChart = CARAT_CONVERSION_CHARTS.find((ccc) => (ccc.stoneType.includes(sg.stone) && ccc.stoneCut.includes(stoneCut) ));   
    if (caratConversionChart) {     
      const caractConversion = caratConversionChart.chart.find((cc) => cc.mm == stoneSize);
      if (caractConversion) {        
       return `${caractConversion.ct}ct (~${stoneSize}mm)`;
      }
    }

    return `${stoneSize}mm`;
  }   

  render = () => {
    const {
      stoneCount,
      stoneCountOptions,
      onStoneCountChange,
      stoneSize,
      stoneSizeOptions,
      onStoneSizeChange,
      stoneGroups,
      currentMenuStoneGroup,
      onCurrentMenuStoneGroupChange,
      scrolling,
      assetURI
    } = this.props;
    const mobile = isMobile();
    const lowHeight = isLowHeight();

    const stoneType = this.props.currentMenuStoneGroup ? this.props.currentMenuStoneGroup.stone : null;

    

    if(!stoneGroups || stoneGroups.length == 0){
      return null
    }

    return (
      <TabContainer className="threed-configurator-menu-stones-tab">        
          <StoneItem>
            {
              stoneGroups.map((s,index)=><StoneConfigs>
                <Dropdown
                  key={index}
                  title={s.name}
                  titleFontWeight={700}
                  width={100}
                  opacity={1}
                  defaultOption={s.stone}
                  defaultImage={`${assetURI}/images/stones/${s.stoneOptions.find((g)=> g == s.stone)}.png`}
                  options={s.stoneOptions.map((s)=>(
                    {
                      value:s,
                      label:s,
                      image: `${assetURI}/images/stones/${s}.png`
                    }
                  ))}
                  onChange={(value) => this.onParameterChange(s.name, 'stone', value)}
                /> 
                 <Dropdown
                    title="Size"
                    titleFontWeight={700}
                    width={100}
                    opacity={1}
                    defaultOption={this._getSize(s,stoneSize)}
                    // options={stoneSizeOptions.map((s)=>({value:s,label:`${s} mm`}))}
                    options={stoneSizeOptions.map((t)=>({value:t,label:this._getSize(s,t)}))}
                    onChange={onStoneSizeChange}
                    disabled={stoneSizeOptions.length <= 1}
                  /> 
              </StoneConfigs>
              )
            }
          </StoneItem>  
      </TabContainer>
    );
  };
};
